import React from 'react'
import {
  DialogTitle,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core'
import { onSnapshot, collection } from 'firebase/firestore'

import { firestore } from '../../../../utils/firebase'

import { globalAlertStyles } from './globalAlertDialogStyles'
// import { listenGlobalAlertDocumentChanges } from './docuUpdateListeners'
function GlobalAlertDialog() {
  const classes = globalAlertStyles()
  const rcpid = localStorage.getItem('rutgersEduRCPID')
  const [showAlert, setShowAlert] = React.useState(false)
  const [alertTitle, setAlertTitle] = React.useState('')
  const [alertContent, setAlertContent] = React.useState('')
  const [alertAuthor, setAlertAuthor] = React.useState('')
  const [loading, setLoading] = React.useState(true) // Add a loading state

  // NOTE "alertTargets": [1,2,3,4,5,6],key can be used to define pre composed alert messages and instructions
  // for specific capmuses or events. e.g.: number 1 can be a general alert, if front end receiceves taht number
  // it can dispatch a query to an endpoint that returns JSON with additional infor or isntructions regarding the
  // alert type. This is to avoid extra wiritng when POSt ing the alert.

  React.useEffect(() => {
    const unsubscribe =
      rcpid &&
      onSnapshot(
        collection(firestore, 'users', rcpid, 'settings'),
        (snapshot) => {
          let foundAlert = false // local variable to track if alertTitle exists
          snapshot.docChanges().forEach((change) => {
            if (change?.type === 'modified') {
              const changedDocument = change.doc.data()
              const hasKeyIn = 'alertTitle' in changedDocument

              if (hasKeyIn) {
                console.log('Modified document:', changedDocument.alertTitle)
                setAlertTitle(changedDocument.alertTitle) // set alert title
                setAlertContent(changedDocument.alertContent)
                setAlertAuthor(changedDocument.alertAuthor)
                foundAlert = true
              }
            }
          })
          setShowAlert(foundAlert) // outside the loop, set showAlert
          setLoading(false) // Set loading to false when data is received
        },
      )

    return () => unsubscribe && unsubscribe()
  }, [rcpid])

  if (loading) {
    console.log('[gAlertDialog]:loading ')
  }
  return (
    <>
      <Dialog
        open={showAlert}
        classes={{ paper: classes.mainDialog }}
        onClose={() => {
          console.log('alert show: ', showAlert)
        }}
      >
        <DialogTitle>
          <Typography variant="subtitle1" className={classes.alertTitle}>
            Global Alert System
          </Typography>
        </DialogTitle>
        <DialogContent dividers className={classes.dialog}>
          <Typography variant="h2" className={classes.alertTitle}>
            {alertTitle}
          </Typography>
          <Typography variant="h5" className={classes.alertBody}>
            {alertContent}
          </Typography>
          <Typography variant="body" className={classes.alertFooter}>
            Issued by: {alertAuthor}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => console.log('acknowledged')}
            color="primary"
          >
            Acknowledged
          </Button>
          <Button
            autoFocus
            onClick={() => setShowAlert(false)}
            color="secpondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default GlobalAlertDialog
